import { PermissionGate } from '@/entities/practice-member';
import type { ClientBalance } from '@/entities/session-charge';
import { formatCurrencyFromCents } from '@/shared/lib/format-utils';

import { ClientDetailsBillingBalance } from './client-details-billing/client-details-billing-balance';

type Props = {
    balance: ClientBalance | undefined;
};

export function ClientDetailsBilling({ balance }: Props) {
    return (
        <PermissionGate
            requiredAccessSources={['CLINICIAN', 'EHR_BASE']}
            fallback={() => (
                <p className="text-base text-muted-foreground">
                    {formatCurrencyFromCents(0)} balance
                </p>
            )}
        >
            <ClientDetailsBillingBalance balance={balance} />
        </PermissionGate>
    );
}
